import { useState } from 'react';

import { toggleFromSet } from '@atom/utilities/setUtilities';

export const RESULTS_PER_PAGE_OPTIONS = [25, 50, 100];

const NO_SELECTION = new Set<string>();

type PhotosPageState = {
  page: number;
  limit: number;
  search: string;
  selectedIds: Set<string>;
};

const INITIAL_PAGE_STATE: PhotosPageState = {
  page: 1,
  limit: RESULTS_PER_PAGE_OPTIONS[0],
  search: '',
  selectedIds: NO_SELECTION,
};

const usePhotosPageState = () => {
  const [pageState, setPageState] =
    useState<PhotosPageState>(INITIAL_PAGE_STATE);

  const onPageChange = (page: number) =>
    setPageState(current => ({ ...current, page, selectedIds: NO_SELECTION }));

  const onLimitChange = (limit: number) =>
    setPageState(current => ({
      ...current,
      limit,
      page: 1,
      selectedIds: NO_SELECTION,
    }));

  const onSearchChange = (search: string) =>
    setPageState(current => ({
      ...current,
      search,
      page: 1,
      selectedIds: NO_SELECTION,
    }));

  const onSelectionToggle = (id: string) =>
    setPageState(current => ({
      ...current,
      selectedIds: toggleFromSet(current.selectedIds, id),
    }));

  const onSelectionChange = (ids: string[]) =>
    setPageState(current => ({ ...current, selectedIds: new Set(ids) }));

  return {
    ...pageState,
    onPageChange,
    onLimitChange,
    onSearchChange,
    onSelectionToggle,
    onSelectionChange,
  };
};

export default usePhotosPageState;
